// MF entry exposed as ./AppMount: loads runtime settings + registers remotes before the app boots.
import { loadAppSettings } from './appSettings';
import { registerRuntimeRemotes } from './designSystemRemote';

// Settings the app can't boot without; validated up front to fail fast with a clear message.
const REQUIRED_SETTINGS = [
  'SHIPBOB_DESIGN_SYSTEM',
  'SHIPBOB_MFE_RUNTIME',
  'AUTHENTICATION_AUTHORITY',
  'CLIENT_ID',
  'CLIENT_SCOPE',
  'MFE_ROOT_ROUTE',
  // Every service base URL the bootloader wires unconditionally — validate them up front so a
  // missing key fails fast instead of issuing requests to "undefined/...". WMS gateway is omitted
  // because bootloader.js falls back to INVENTORY_MANAGEMENT_API_BASEURL when it is absent.
  'INVENTORY_MANAGEMENT_API_BASEURL',
  'LOCATION_MANAGEMENT_API_BASEURL',
  'FACILITY_WORKFLOW_INTEGRATION_API_BASEURL',
  'PUBLIC_LOCATIONS_BASEURL',
  'ONEID_MEMBERSHIP_BASEURL',
  'PRODUCTS_MANAGEMENT_API_BASEURL',
];

/** Load settings, validate required keys (throws listing any missing), then register the remotes. */
export async function prepareRuntime(action) {
  const appSettings = await loadAppSettings();

  const missing = REQUIRED_SETTINGS.filter(
    (key) => typeof appSettings[key] !== 'string' || !appSettings[key].trim(),
  );
  if (missing.length) {
    throw new Error(`[inventory-management-ui] cannot ${action}: missing required app settings: ${missing.join(', ')}`);
  }

  registerRuntimeRemotes(appSettings);
}

/** Mount into a host-provided element; returns the bootloader's unmount fn. */
export const mount = async (args = {}) => {
  await prepareRuntime('mount');
  const { mount: appMount } = await import('./bootloader');
  return appMount(args);
};
